// src/features/chat/components/his/WhisperFold.jsx
/*
 * A contiguous run of settled whispers folds into one quiet line — texture,
 * not tasks. It sits in the Recoverable tier: naming its size, asking for
 * nothing, expanding in place on demand.
 */

import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import styles from '../../styles/HisArtifact.module.css';
import Collapse from './Collapse';

export function WhisperFold({ fold, expanded = false, onToggle, renderItem }) {
  const count = fold?.count || fold?.items?.length || 0;
  return (
    <div className={styles.fold}>
      <button
        type="button"
        className={styles.foldLine}
        onClick={() => onToggle?.(fold.id)}
        aria-expanded={expanded}
      >
        {count} quiet {count === 1 ? 'change' : 'changes'}
        {expanded ? (
          <ChevronUp size={12} aria-hidden="true" />
        ) : (
          <ChevronDown size={12} aria-hidden="true" />
        )}
      </button>
      <Collapse open={expanded}>
        <div className={styles.foldItems}>
          {fold.items.map((item) => renderItem(item))}
        </div>
      </Collapse>
    </div>
  );
}

export default WhisperFold;
